import React from 'react';
import { Check, ArrowRight } from 'lucide-react';
import { STARTUP_FEATURES, IMAGES } from '../mock';

const StartupCoaching = () => {
  return (
    <section className="py-24 bg-[#f6f9fc]">
      <div className="max-w-[1280px] mx-auto px-6 grid lg:grid-cols-2 gap-14 items-center">
        <div className="relative">
          <img src={IMAGES.startup} alt="Startup consulting" className="w-full h-[500px] object-cover rounded-2xl shadow-xl" />
          <img src={IMAGES.team} alt="Team" className="hidden md:block absolute -bottom-8 -right-6 w-56 h-56 object-cover rounded-2xl shadow-xl border-4 border-white" />
        </div>
        <div>
          <p className="eyebrow mb-3">STARTUP COACHING</p>
          <h2 className="section-title text-4xl md:text-5xl mb-4">Startup &amp; Early Consulting</h2>
          <h3 className="font-serif-display text-[#0a6cb0] text-xl md:text-2xl italic mb-6">
            We&apos;re here to inform which tactics need funding and which are draining resources.
          </h3>
          <p className="text-[#556a85] text-[15px] leading-relaxed mb-6">
            Our team is a diverse network of consultants and industry professionals with a global mindset and
            a collaborative culture. We work to understand your issues and are driven to ask better questions in
            the pursuit of making your business work better.
          </p>
          <div className="mb-8">
            {STARTUP_FEATURES.map((f) => (
              <div key={f} className="check-item">
                <span className="w-6 h-6 rounded-full bg-[#0a6cb0] text-white flex items-center justify-center">
                  <Check size={14} />
                </span>
                <span>{f}</span>
              </div>
            ))}
          </div>
          <a href="#services" className="pill-btn pill-btn-outline">
            TAKE THE NEXT STEP <ArrowRight size={18} />
          </a>
        </div>
      </div>
    </section>
  );
};

export default StartupCoaching;
